module.exports = __webpack_public_path__ + "static/assets/d3399664034c5fedce7256c06effc173.gif";